mutation UpdateDirectorySyncSettings($input: UpdateDirectorySyncSettingsInput!) {
    updateDirectorySyncSettings(input: $input) {
        directorySync {
            isConfigured
            defaultRole {
                id
                name
            }
        }
    }
}
